"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TabularAnalyticsController_1 = __importDefault(require("../modules/controllers/TabularAnalyticsController"));
const PolygonGeodata_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/PolygonGeodata.vue"));
const CropLabel_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/CropLabel.vue"));
const FieldActions_vue_1 = __importDefault(require("@becrop/components/TabularAnalytics/components/FieldActions.vue"));
const CheckSet_vue_1 = __importDefault(require("./CheckSet.vue"));
const RankTag_vue_1 = __importDefault(require("./RankTag.vue"));
const ViewZero_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/ViewZero.vue"));
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
let FieldsTable = class FieldsTable extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.TABULAR_ANALYTICS_CONTROLLER = TabularAnalyticsController_1.default.getInstance();
        this.fieldsOrder = [];
        this.tableKey = 0;
        this.filters = {
            global: { value: '', matchMode: 'contains' }
        };
    }
    forceUpdateTable() {
        this.tableKey++;
    }
    createAcreage(value, unit) {
        if (value == null || unit == null || isNaN(value)) {
            return '-';
        }
        return new Acreage_1.default(value, unit, true).value;
    }
    get headerRows() {
        let rows = 1; // fila principal (Name, Date, … Metrics)
        // si hay Recommendations, añado +1
        if (this.TABULAR_ANALYTICS_CONTROLLER.configuration.isPresetActive('recommendations')) {
            rows++;
        }
        // si hay Needs, añado fila de encabezado de Needs y posiblemente la de rangos de Needs
        if (this.TABULAR_ANALYTICS_CONTROLLER.configuration.isPresetActive('needs')) {
            rows++; // row de títulos de Needs
            if (this.TABULAR_ANALYTICS_CONTROLLER.configuration.mode === 'rank_distribution') {
                rows++; // row de rangos de Needs
            }
        }
        // si hay Metrics, añado filas de categorías, métricas y rangos de métricas
        if (this.TABULAR_ANALYTICS_CONTROLLER.configuration.isPresetActive('metrics')) {
            rows++; // row de categorías
            rows++; // row de métricas
            if (this.TABULAR_ANALYTICS_CONTROLLER.configuration.mode === 'rank_distribution') {
                rows++; // row de rangos de métricas
            }
        }
        if (this.TABULAR_ANALYTICS_CONTROLLER.configuration.isPresetActive('phch_metrics')) {
            rows++;
        }
        return rows;
    }
    sortFarmsByNeedRank(field, order) {
        const regex = /^need-(\d+)-level-(\d+)$/;
        const match = field === null || field === void 0 ? void 0 : field.match(regex);
        if (!match || order === null) {
            this.fieldsOrder = []; // Restablecer al orden original
            return this.fieldsOrder;
        }
        const needIndex = parseInt(match[1], 10);
        const levelIndex = parseInt(match[2], 10);
        const rankLevels = ['veryLow', 'low', 'medium', 'high', 'veryHigh'];
        const rankKey = rankLevels[levelIndex];
        if (this.TABULAR_ANALYTICS_CONTROLLER.configuration.mode === 'rank_distribution') {
            this.fieldsOrder = [...this.currentFarm.fieldsAnalytics].sort((a, b) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                const aValue = (_f = (_e = (_d = (_c = (_b = (_a = a.breakdownNeeds) === null || _a === void 0 ? void 0 : _a[needIndex]) === null || _b === void 0 ? void 0 : _b.ranks) === null || _c === void 0 ? void 0 : _c[rankKey]) === null || _d === void 0 ? void 0 : _d.acreageByFarm) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : 0;
                const bValue = (_m = (_l = (_k = (_j = (_h = (_g = b.breakdownNeeds) === null || _g === void 0 ? void 0 : _g[needIndex]) === null || _h === void 0 ? void 0 : _h.ranks) === null || _j === void 0 ? void 0 : _j[rankKey]) === null || _k === void 0 ? void 0 : _k.acreageByFarm) === null || _l === void 0 ? void 0 : _l.value) !== null && _m !== void 0 ? _m : 0;
                return order * (aValue - bValue);
            });
        }
        else {
            this.fieldsOrder = [...this.currentFarm.fieldsAnalytics].sort((a, b) => {
                var _a, _b, _c, _d, _e, _f;
                const aValue = (_c = (_b = (_a = a.breakdownNeeds) === null || _a === void 0 ? void 0 : _a[needIndex]) === null || _b === void 0 ? void 0 : _b.valueByFarm) !== null && _c !== void 0 ? _c : 0;
                const bValue = (_f = (_e = (_d = b.breakdownNeeds) === null || _d === void 0 ? void 0 : _d[needIndex]) === null || _e === void 0 ? void 0 : _e.valueByFarm) !== null && _f !== void 0 ? _f : 0;
                return order * (aValue - bValue);
            });
        }
        return this.fieldsOrder;
    }
    sortFarmsByMetricRank(field, order) {
        const regex = /^met-(.+)-level-(\d+)$/;
        const match = field === null || field === void 0 ? void 0 : field.match(regex);
        if (!match || order === null) {
            this.fieldsOrder = [];
            return this.fieldsOrder;
        }
        const metricCode = match[1];
        const levelIndex = parseInt(match[2], 10);
        const rankLevels = ['veryLow', 'low', 'medium', 'high', 'veryHigh'];
        const rankKey = rankLevels[levelIndex];
        this.fieldsOrder = [...this.currentFarm.fieldsAnalytics].sort((a, b) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            const aMetric = this.findMetricInFarm(a, metricCode);
            const bMetric = this.findMetricInFarm(b, metricCode);
            if (this.TABULAR_ANALYTICS_CONTROLLER.configuration.mode === 'rank_distribution') {
                const aValue = (_d = (_c = (_b = (_a = aMetric === null || aMetric === void 0 ? void 0 : aMetric.ranks) === null || _a === void 0 ? void 0 : _a[rankKey]) === null || _b === void 0 ? void 0 : _b.acreageByFarm) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 0;
                const bValue = (_h = (_g = (_f = (_e = bMetric === null || bMetric === void 0 ? void 0 : bMetric.ranks) === null || _e === void 0 ? void 0 : _e[rankKey]) === null || _f === void 0 ? void 0 : _f.acreageByFarm) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : 0;
                return order * (aValue - bValue);
            }
            else {
                const aValue = (_j = aMetric === null || aMetric === void 0 ? void 0 : aMetric.valueByFarm) !== null && _j !== void 0 ? _j : 0;
                const bValue = (_k = bMetric === null || bMetric === void 0 ? void 0 : bMetric.valueByFarm) !== null && _k !== void 0 ? _k : 0;
                return order * (aValue - bValue);
            }
        });
        return this.fieldsOrder;
    }
    findMetricInFarm(farm, metricCode) {
        var _a;
        for (const group of (_a = farm.breakdownMetrics) !== null && _a !== void 0 ? _a : []) {
            const metric = group.metrics.find(m => m.name === metricCode);
            if (metric)
                return metric;
        }
        return undefined;
    }
    customSortPHCH(field, order) {
        this.fieldsOrder = [...this.currentFarm.fieldsAnalytics].sort((a, b) => {
            var _a, _b, _c, _d, _e, _f;
            const name = field.split('-').slice(2).join('-'); // Extrae el nombre real
            const valA = (_c = (_b = (_a = a.breakdownPHCH) === null || _a === void 0 ? void 0 : _a.find((item) => item.name + item.unit === name)) === null || _b === void 0 ? void 0 : _b.valueByFarm) !== null && _c !== void 0 ? _c : null;
            const valB = (_f = (_e = (_d = b.breakdownPHCH) === null || _d === void 0 ? void 0 : _d.find((item) => item.name + item.unit === name)) === null || _e === void 0 ? void 0 : _e.valueByFarm) !== null && _f !== void 0 ? _f : null;
            if (valA == null && valB == null)
                return 0;
            if (valA == null)
                return 1;
            if (valB == null)
                return -1;
            return (valA - valB) * order;
        });
    }
    onSortChange(event) {
        const field = event.sortField;
        if (field) {
            if (field.startsWith('need-')) {
                this.sortFarmsByNeedRank(event.sortField, event.sortOrder);
            }
            if (field.startsWith('met-')) {
                this.sortFarmsByMetricRank(event.sortField, event.sortOrder);
            }
            if (field.startsWith('phch-')) {
                this.customSortPHCH(event.sortField, event.sortOrder);
            }
        }
        this.mixpanelHandler.trackEvent('sortingTabular', {
            column: field,
            order: event.sortOrder,
            level: this.TABULAR_ANALYTICS_CONTROLLER.tabularMode,
        });
    }
    downloadReport(gisFieldId) {
        this.mixpanelHandler.trackEvent('downloadPDFTabular', {
            level: this.TABULAR_ANALYTICS_CONTROLLER.tabularMode,
        });
        const url = '/data/results/gis-field/pdf/' + gisFieldId;
        const link = document.createElement('a');
        link.href = url;
        document.body.appendChild(link);
        window.open(url);
    }
    formatHeader(text) {
        if (!text)
            return '';
        const withSpaces = text.replace(/([A-Z])/g, ' $1');
        return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
    }
    get fields() {
        return this.currentFarm.fieldsAnalytics;
    }
    get globalFilter() {
        return this.TABULAR_ANALYTICS_CONTROLLER.searchCriteria;
    }
    mounted() {
        this.table = this.$refs.advancedTableFields;
        this.TABULAR_ANALYTICS_CONTROLLER.fieldsTableRef = this.$refs.advancedTableFields;
        this.TABULAR_ANALYTICS_CONTROLLER.tabularMode = 'fields';
    }
    onGlobalFilterChange(newValue) {
        this.filters.global.value = newValue;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], FieldsTable.prototype, "currentFarm", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('globalFilter', { immediate: true })
], FieldsTable.prototype, "onGlobalFilterChange", null);
FieldsTable = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { AdvancedTable: bmk_ui_framework_1.AdvancedTable, Column: bmk_ui_framework_1.Column, ColumnGroup: bmk_ui_framework_1.ColumnGroup, Row: bmk_ui_framework_1.Row, DateStylized: bmk_ui_framework_1.DateStylized, PolygonGeodata: PolygonGeodata_vue_1.default, CropLabel: CropLabel_vue_1.default, FieldActions: FieldActions_vue_1.default, CheckSet: CheckSet_vue_1.default, RankTag: RankTag_vue_1.default, ViewZero: ViewZero_vue_1.default, WarningRoundedIcon: bmk_ui_framework_1.WarningRoundedIcon }
    })
], FieldsTable);
exports.default = FieldsTable;
